export type EssenceContract = {
  name: string;
  address: `0x${string}`;
  basescanPath: 'token' | 'address';
  note?: string;
};

export const BASE_CHAIN_ID = 8453;
export const BASE_CHAIN_LABEL = 'Base mainnet';

/** Live Base mainnet contracts — product source of truth. */
export const ESSENCE_CONTRACTS: EssenceContract[] = [
  {
    name: 'ESSENCE token',
    address: '0xf46d7037C064d6180D41127F63cC371Ab80bE639',
    basescanPath: 'token',
  },
  {
    name: 'EssenceTreasury',
    address: '0xaAf64C8116Ea66CcD77Db11381b6b4350f823a3f',
    basescanPath: 'address',
    note: 'USDC vault that backs mint when funded',
  },
  {
    name: 'EssenceBridge',
    address: '0xcaC86eFB10aeb19038FDAf3DE0979048E69BFFa5',
    basescanPath: 'address',
    note: 'Only minter — admin/bridge-controlled mint',
  },
];

export const USDC_BASE: EssenceContract = {
  name: 'USDC (Circle on Base)',
  address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  basescanPath: 'token',
};

export function basescanUrl(contract: EssenceContract): string {
  return `https://basescan.org/${contract.basescanPath}/${contract.address}`;
}

export function shortAddress(address: string): string {
  return `${address.slice(0, 6)}…${address.slice(-4)}`;
}
